export default __webpack_public_path__ + "static/media/Logo.68243758.svg";